import { Link } from "react-router-dom"


export const BacktoTop = ()=>{
    return(
        <>
            <div className="amazon-back-to-top text-center py-3">
                <Link to="" className="text-white">Back to top</Link>
            </div>
        </>
    )
}
